import { useDispatch, useSelector } from 'react-redux';

import BomOptions from './nextgen/bom-options/components/BomOptions';
import Error from './main/components/Error';
import PriceRecalculationTrigger from './ordersummary/components/PriceRecalculationTrigger';
import React from 'react';
import SingletonMessageBox from './common/SingletonMessageBox';
import TokenTimeout from './main/components/TokenTimeout';
import { catchErrorInfo } from './main/logics';
import { configuratorStep } from './main/constants';
import { dispatchBomOptionsErrorEvent } from './bom/logics';
import { getCurrentStep } from './main/selectors';
import { setCurrentStep } from './main/actions';
import { useErrorBoundary } from 'use-error-boundary';

const BomOptionsApp = () => {
  const dispatch = useDispatch();
  const { ErrorBoundary } = useErrorBoundary();
  const currentStep = useSelector(getCurrentStep);

  return (
    <ErrorBoundary
      render={() => (
        <>
          <TokenTimeout autoRefresh />
          {currentStep === configuratorStep.error ? (
            <Error />
          ) : (
            <>
              <SingletonMessageBox />
              <PriceRecalculationTrigger />
              {currentStep === configuratorStep.bom && <BomOptions />}
            </>
          )}
        </>
      )}
      renderError={(props) => {
        !!props && !!props.error && dispatch(catchErrorInfo(props.error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatchBomOptionsErrorEvent(!!props && !!props.error ? props.error : null);
        return <Error />;
      }}
    />
  );
};

export default BomOptionsApp;
